/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_All_FormatsInputs */



/**
* | output |
* | --- |
* | "All Formats" |
*
* @param {Tournaments_All_FormatsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_all_formats = /** @type {((inputs?: Tournaments_All_FormatsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_All_FormatsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tous les formats")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todos los formatos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Todos os Formatos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutti i Formati")
	return /** @type {LocalizedString} */ ("All Formats")
});